import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { TooltipInfoWrapper } from './styles'

export const UnitTooltip = () => {
	const { t } = useTranslation()

	return (
		<TooltipInfoWrapper>
			<Stack padding={2}>
				<Typography variant="body2">
					{t('tooltip.emissionsUnitBody')}
				</Typography>
			</Stack>
		</TooltipInfoWrapper>
	)
}
